import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import {
  AuthService,
  ClientService,
} from 'src/app/core/services';
import { Observable, Observer, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  IClient,
  IRestaurantDto,
} from 'src/app/core/models';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public client: IClient[];
  public clientConfig: IClient;
  public restaurantList: IRestaurantDto[];
  public isInternetActive: boolean = true;

  constructor(
    private readonly clientService: ClientService,
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly authService: AuthService
  ) {
    this.clientConfig = this.clientService.currentClientValue;
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        if (
          data.url.indexOf('/orders/OrderReceipt') > -1 ||
          data.url.indexOf('/home/tc-m') > -1
        ) {
          this.clientConfig = null;
        }
        this.updateTitleForUrl(data.url);
      }
    });
  }

  updateTitleForUrl(url: string): void {
    const brand = this.clientConfig?.title || 'Online Ordering';
    let page = '';
    const cleanUrl = url.split('?')[0].split('#')[0];

    if (cleanUrl.startsWith('/home/menu')) {
      page = 'Our Menu';
    } else if (cleanUrl.startsWith('/home/about-us')) {
      page = 'About Us';
    } else if (cleanUrl.startsWith('/home/events')) {
      page = 'Events';
    } else if (cleanUrl.startsWith('/home/coupons')) {
      page = 'Coupons';
    } else if (cleanUrl.startsWith('/home/reservation')) {
      page = 'Table Reservation';
    } else if (cleanUrl.startsWith('/home/orders')) {
      page = 'My Orders';
    } else if (cleanUrl.startsWith('/home/rewards')) {
      page = 'My Rewards';
    } else if (cleanUrl.startsWith('/home/address')) {
      page = 'My Addresses';
    } else if (cleanUrl.startsWith('/home/tc')) {
      page = 'Terms and Conditions';
    } else if (cleanUrl.startsWith('/home/privacy-policy')) {
      page = 'Privacy Policy';
    } else if (cleanUrl.startsWith('/checkout') || cleanUrl.startsWith('/Checkout')) {
      page = 'Checkout';
    } else if (cleanUrl.startsWith('/giftcard')) {
      page = 'Gift Cards';
    } else if (cleanUrl.startsWith('/auth/profile')) {
      page = 'My Account';
    } else if (cleanUrl.startsWith('/auth/deactivate')) {
      page = 'Deactivate Account';
    } else if (cleanUrl.startsWith('/orders/OrderReceipt')) {
      page = 'Order Receipt';
    } else if (cleanUrl.startsWith('/not-found')) {
      page = 'Page Not Found';
    } else if (cleanUrl === '/home' || cleanUrl === '/') {
      page = 'Home';
    }

    if (page) {
      this.titleService.setTitle(`${page} | ${brand}`);
    } else {
      this.titleService.setTitle(brand);
    }
  }

  checkInternet$() {
    return merge<boolean>(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
  }

  ngOnInit(): void {
    this.clientService.currentClient.subscribe((client) => {
      this.clientConfig = client;
    });

    this.checkInternet$().subscribe((isOnline) => {
      if (isOnline) {
        this.isInternetActive = true;
      } else {
        this.isInternetActive = false;
      }
    });
    this.validateClient();
  }

  validateClient() {
    if (this.clientConfig) {
      this.updateTitleForUrl(this.router.url);
      this.authService.onAppLoad();
    } else {
      this.clientService.setCurrentClient(null, false);
      alert('Error! Not able to fetch the Restaurant Details');
      this.router.navigate(['not-found']);
    }
  }
}
